/// <amd-module name="TFS/Admin/Views/ProjectPermissions/Helpers/ProjectPermissionsHelper" />
import { ITfsPageService, IProjectData } from "Tfs/Platform/Page";
import { IPermissionsMessage } from "../Contracts/DataModels";
import * as Resources from "TFS/Admin/Views/ProjectPermissions/Resources";
import { MessageCardSeverity } from "VSSUI/MessageCard";
import * as String from "VSS/Core/Util/String";
import { IVssComponentContext } from "VSS/Platform/Layout";

export abstract class ProjectPermissionsHelper {
    public static getProject(context: IVssComponentContext): IProjectData | undefined {
        const pageService = context.pageContext.getService<ITfsPageService>("ITfsPageService");
        const pageData = pageService.getData();

        if (!pageData || !pageData.project) {
            return undefined;
        }

        return pageData.project;
    }

    public static parseAddMembersResult(resultMembers: any): IPermissionsMessage {
        let resultMessage: string;
        let cardSeverity: MessageCardSeverity;
        if (resultMembers.success.length === 0) {
            // No success elements; all failed
            resultMessage = Resources.AddMembersFailed;
            cardSeverity = MessageCardSeverity.Error;
        } else if (resultMembers.failed.length > 0) {
            // Some success elements however some failed elements aswell
            resultMessage = String.format(Resources.AddMembersPartialSuccess, resultMembers.success.length, resultMembers.failed.length);
            cardSeverity = MessageCardSeverity.Warning;
        } else {
            resultMessage = String.format(Resources.AddMembersSuccess, resultMembers.success.length);
            cardSeverity = MessageCardSeverity.Info;
        }

        return { name: resultMessage, severity: cardSeverity } as IPermissionsMessage;
    }
}
